import React, {Component} from "react";

import Logo from "./img/logo.png";
import Background from "./img/sfondolore.png";

import Navbar from "./components/navbar";
import { Container, Stack, Text, Image, Box, Center } from "@chakra-ui/react";
import Immagine1 from "./img/immaginelore1.png";
import Immagine2 from "./img/immaginelore2.png";
import Immagine3 from "./img/immaginelore3.png";
import Immagine4 from "./img/immaginelore4.png";


export default class Roadmap extends Component {
    render() {
      return (
        <>
            <div className='container-fluid' style={{backgroundImage: "url(" + Background + ")", backgroundRepeat: "no-repeat", backgroundSize: "5500px", height: "3300px", weight: "1920px"}}>                
                <Navbar 
                img={Logo}
                color="#ffffff"/>
                <Center p={6}>
                  <Stack direction={['column', 'row']} spacing='140px' h='650px'>
                    <Container w='100%' h='200px' bg='trasparent' p={12} centerContent>
                      <Box bg='trasparent'   w='370px'>
                        <Text fontSize= '23px' style={{fontFamily:"Roboto", color: "#ffffff"}}>Il nome della società è un netto riferimento al carnevale italiano: Carnival Society nasce dal concetto di carnevale, evento che prende forma nelle celebrazioni pagane dei saturnali e dalle feste dionisiache romane.
                        </Text>
                      </Box>
                    </Container>
                    <Container w='100%' h='350px' bg='trasparent' centerContent>
                      <Box bg='trasparent'   w='350px'>
                        <Image src={Immagine1} maxW='500px' boxSize='300px' borderRadius='full' />
                      </Box>
                    </Container>
                  </Stack>
                </Center>
                <Center>
                  <Stack direction={['column', 'row']} spacing='150px' h='650px'>
                    <Container w='100%' h='200px' bg='trasparent' centerContent>
                      <Box bg='trasparent'   w='370px'>
                        <Text fontSize= '23px' style={{fontFamily:"Roboto", color: "#ffffff"}}>Venivano celebrate dei festeggiamenti che dovevano essere di buon auspicio in cui era necessaria la maschera per relazionarsi e ingraziarsi la divinità in questione. 
                          Dopodiché le prime ricorrenze del carnevale “moderno” risalgono al VIII sec. in cui veniva allestito un grande e prosperoso banchetto prima dell’inizio del digiuno.
                        </Text>
                      </Box>
                    </Container>
                    <Container w='100%' h='350px' bg='trasparent' centerContent>
                      <Box bg='trasparent'   w='350px'>
                        <Image src={Immagine2} maxW='500px' boxSize='300px' borderRadius='full' />
                      </Box>
                    </Container>
                  </Stack>
                </Center>
                <Center>
                  <Stack direction={['column', 'row']} spacing='150px' h='650px'>
                    <Container w='100%' h='200px' bg='trasparent' centerContent>
                      <Box bg='trasparent'   w='370px'>
                        <Text fontSize= '23px' style={{fontFamily:"Roboto", color: "#ffffff"}}>Durante questo evento l’ordine sociale era completamente sovvertito, perciò povero e nobile potevano ritrovarsi allo stesso desco, appianando qualsiasi divergenza sociale, gerarchica e di rango. L’atmosfera del banchetto era goliardica, spensierata e leggera in cui lo scopo principale era il divertimento senza limitazioni gerarchiche.
                        </Text>
                      </Box>
                    </Container>
                    <Container w='100%' h='350px' bg='trasparent' centerContent>
                      <Box bg='trasparent'   w='350px'>
                        <Image src={Immagine3} maxW='500px' boxSize='300px' borderRadius='full' />
                      </Box>
                    </Container>
                  </Stack>
                </Center>
                <Center>
                  <Stack direction={['column', 'row']} spacing='150px' h='650px'>
                    <Container w='100%' h='200px' bg='trasparent' p={9} centerContent>
                      <Box bg='trasparent'   w='370px'>
                        <Text fontSize= '23px' style={{fontFamily:"Roboto", color: "#ffffff"}}>La Carnival Society si vuole quindi fondare su questo concetto di ribaltamento sociale e soprattutto di anonimato grazie all’uso delle maschere che permettono di uniformare il livello d’insieme.
                        </Text>
                      </Box>
                    </Container>
                    <Container w='100%' h='350px' bg='trasparent' centerContent>
                      <Box bg='trasparent'   w='350px'>
                        <Image src={Immagine4} maxW='500px' boxSize='300px' borderRadius='full' />
                      </Box>
                    </Container>
                  </Stack>
                </Center>
              </div>                         
        </>
      );
    }
  }